import React, { useEffect } from "react";
import ReactGA from "react-ga4";

// components
import Hero from "../components/hero/Hero";
import HmcAssets from "../components/hmc-assets/HmcAssets";
import InvestmentFocus from "../components/investment-focus/InvestmentFocus";
import HowDiWorks from "../components/howDiWorks/HowDiWorks";
import DiGrowthDrivers from "../components/diGrowthDrivers/DiGrowthDrivers";
// import AboutUs from "../components/aboutUs/AboutUs";
// import StatsSection from "../components/stats-section/StatsSection";
// import InvestmentObjectives from "../components/investment-objectives/InvestmentObjectives";
import PrePreFooter from "../components/pre-footer/PrePreFooter";
import PreFooter from "../components/pre-footer/PreFooter";
import Footer from "../components/footer/Footer";

const PageOne = () => {
  useEffect(() => {
    const currentPage = window.location.pathname;
    ReactGA.send({
      hitType: "pageview",
      page: "/",
      title: "home page",
    });
    // console.log("GA Page View Sent:", currentPage); // Debugging
  }, []);
  return (
    <>
      <Hero />
      <HmcAssets />
      <InvestmentFocus />
      <HowDiWorks />
      <DiGrowthDrivers />
      {/* <AboutUs />
      <StatsSection />
      <InvestmentObjectives /> */}
      <PrePreFooter>
        <ol className="list-decimal">
          <li className="text-base">
            Investing in digital infrastructure assets does not assure a profit
            or protect against losses. DIR is a REIT of indefinite duration. See
            the “Risk Factors – General Risks Related to Digital Infrastructure
            Real Estate Assets” section of the prospectus for more details.
          </li>
          <li className="text-base">
            Source: Ericsson Mobility Report, November 2023
          </li>
          <li className="text-base">
            Source: Acumen Research and Consulting, October 12, 2023
          </li>
          <li className="text-base">
            Source: Market.US, January 2024, “Artificial Intelligence Market,
            Forecast 2023-2032”
          </li>
          <li className="text-base">
            There is no guarantee that these investment objectives will be met
            and are not business day priced on an Exchange.
          </li>
          <li className="text-base">
            The availability and timing of distributions DIR may pay is
            uncertain and cannot be assured. Distributions have historically
            exceeded earnings. If DIR pays distributions from sources other than
            cash flow from operations, DIR will have less funds available for
            the acquisition of properties, and stockholder’s overall return may
            be reduced.
          </li>
          <li className="text-base">
            DIR’s shares are sold at the “transaction price” plus applicable
            up-front selling commissions and fees. The transaction price
            generally will be equal to the NAV per share determined as of the
            end of the prior month. Accordingly, DIR’s offering price per share
            may be subject to less volatility because its NAV per share is based
            on the value of real estate assets it owns and is not subject to
            market pricing forces as are the share prices of publicly traded
            REITs. The value of DIR’s underlying investments may fluctuate and
            may be worth less than DIR initially paid for them. Although the
            offering price is subject to less volatility, DIR shares are
            significantly less liquid than shares of a publicly traded REIT, and
            are not immune to fluctuations.
          </li>
          <li className="text-base">
            While DIR’s advisor is more closely aligned with investors, it is
            not completely aligned. DIR will also face conflicts of interest as
            a result of, among other things, the allocation of investment
            opportunities among us and other affiliates of DIR, the allocation
            of time of its investment professionals and the substantial fees and
            expense reimbursements that are not tied to total annual returns
            that DIR will pay to affiliates of StratCap. We are dependent on the
            advisor to conduct our operations. The advisor will face conflicts
            of interest as a result of, among other things, the allocation of
            investment opportunities among us and other investment vehicles, the
            allocation of time of its investment professionals, and the
            substantial fees that we will pay to the advisor.
          </li>
          <li className="text-base">
            On a monthly basis, stockholders may request that we repurchase all
            or any portion of their shares. Repurchases are discretionary and
            will generally be limited to no more than 1.67% of our aggregate NAV
            per month and no more than 5% of our aggregate NAV per calendar
            quarter. Shares that have not been outstanding for at least one year
            will be subject to an “Early Repurchase Deduction” and repurchased
            at 95% of the transaction price. The DIR board of directors may
            suspend or amend the share repurchase program without stockholder
            approval; stockholders may not be able to repurchase their shares.
            The share repurchase program is subject to additional terms and
            limitations as described in the prospectus. Subject to the
            limitations and restrictions of the share repurchase program,
            stockholders may request that DIR redeem their shares on a
            continuous basis, but DIR is not obligated to redeem any shares and
            may choose to redeem only some, or even none, of the shares that
            have been requested to be redeemed in any particular month at DIR’s
            discretion. Further, while DIR may consider a liquidity event at any
            time in the future, DIRcurrently does not have a fixed time frame in
            which it intends to undertake such consideration and DIR is not
            obligated by its charter or otherwise to affect a liquidity event at
            any time.
          </li>
          <li className="text-base">
            Diversification does not assure a profit or protect against losses
            in a declining market.
          </li>
        </ol>
      </PrePreFooter>
      <PreFooter />
      <Footer />
    </>
  );
};

export default PageOne;
